export default "__VITE_ASSET__BNJTVVij__"